<template>
  <app-layout>
    <PageTitle :headerTitle="title"> </PageTitle>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
        <a class="btn-close text-blue-500  bg-white border rounded text-sm pl-2 pr-2 pt-1 pb-1 hover:no-underline" :href="'/'+moduleRoute"> Back</a> &nbsp;
    </div>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
      <div class="w-full">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <!-- <div class="text-lg font-bold ">Create {{moduleName}}</div> -->
            <form @submit.prevent="submit">
              <BsEdit :createDef="createDef" :routeDef="moduleRoute" :modelData="modelData" ref="formRenderer"> </BsEdit>
              <div class="panel-footer mt-2">
                      <a :href="'/'+moduleRoute" class="btn-close text-blue-500  border rounded text-sm pl-2 pr-2 pt-1 pb-1 hover:no-underline"> Back</a> &nbsp;&nbsp;
                      <button @click="" v-show="!checkAction()" type="submit" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline">Submit</button>
                      <jet-button v-show="checkAction()" @click="editItem"  class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"  > Update </jet-button>
                      <!-- <input class="bg-blue-500 text-white text-xs hover:bg-blue-700  py-1  px-3 rounded" type="submit" value="Save"/> -->
              </div>
            </form>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import {save_user_credentials} from './js/configuration.js';

const modelData = {};

export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
  },
  data: function () {
    return {
    title:this.moduleRoute+" Create",
    metas:"",
    user_credentials:{}
    };
  },
  methods: {
    checkAction()
    {
      return (this.modelData.hasOwnProperty("id") && this.modelData.id != "")
    },
    submit() {
                // console.log(this.$refs.formRenderer.formData)                
               // this.$inertia.post('/'+this.moduleRoute, this.$refs.formRenderer.formData)
                save_user_credentials(this.$refs.formRenderer.formData);
            },
    update()
    {
        this.$inertia.put(route(this.moduleRoute+'.update', this.$refs.formRenderer.formData))
    },
     getCookie() {
        const cookie_value = `; ${document.cookie}`;
        return cookie_value.split(";")[1].split("=")[1];
      },
      submit_to_electron(user_credentials){
        
      }
  },
  mounted() {
     this.metas=this.getCookie();
        console.log(this.modelData.hasOwnProperty("id"));
        console.log("createDef");
        console.log(this.createDef);
  },
};
</script>



<style>

    


</style>